import { render, staticRenderFns } from "./ChgPosObsrvRcrdMdl.vue?vue&type=template&id=3eb7b4a6&"
import script from "./ChgPosObsrvRcrdMdl.vue?vue&type=script&lang=js&"
export * from "./ChgPosObsrvRcrdMdl.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports